import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import VitalsMock from "./VitalsMock";
import { useSection } from "../../../i18n/useSection";

/**
 * Route entry for the mock Vitals capture flow. Wires the presentational
 * `VitalsMock` component to app navigation and a save confirmation.
 */
const VitalsScreen = () => {
  const navigate = useNavigate();
  const t = useSection("vitals");
  const [snackOpen, setSnackOpen] = useState(false);

  const handleClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleSave = useCallback(
    (vitals) => {
      // Mock save — nothing is persisted. Surface a confirmation then exit.
      // eslint-disable-next-line no-console
      console.log("Mock vitals saved:", vitals);
      setSnackOpen(true);
      setTimeout(() => navigate(-1), 900);
    },
    [navigate],
  );

  return (
    <>
      <VitalsMock onClose={handleClose} onSave={handleSave} />
      <Snackbar
        open={snackOpen}
        autoHideDuration={2000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          {t.saved}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VitalsScreen;
